import React from 'react';
import styled from 'styled-components';

const HeroSection = styled.section`
  height: 100vh;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, ${props => props.theme.colors.primary.background} 0%, ${props => props.theme.colors.primary.lighter} 100%);
  position: relative;
  overflow: hidden;
  padding-top: 80px; /* Account for fixed header */
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 30% 50%, rgba(0, 178, 169, 0.1) 0%, transparent 70%);
    z-index: 1;
  }
`;

const HeroContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
  z-index: 2;
  width: 100%;
`;

const HeroTitle = styled.h1`
  font-size: ${props => props.theme.fontSizes.h1};
  margin-bottom: 1rem;
  
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    font-size: 2.5rem;
  }
`;

const HeroSubtitle = styled.h2`
  font-size: ${props => props.theme.fontSizes.h3};
  color: ${props => props.theme.colors.accent.teal};
  margin-bottom: 2rem;
  font-weight: 500;
  
  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    font-size: 1.5rem;
  }
`;

const HeroText = styled.p`
  font-size: 1.2rem;
  max-width: 600px;
  margin-bottom: 2rem;
  color: ${props => props.theme.colors.text.secondary};
`;

const CTAButton = styled.a`
  display: inline-block;
  background-color: ${props => props.theme.colors.accent.teal};
  color: #fff;
  padding: 0.8rem 2rem;
  border-radius: 4px;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background-color: ${props => props.theme.colors.accent.coral};
    transform: translateY(-2px);
  }
`;

const ScrollIndicator = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${props => props.theme.colors.text.secondary};
  font-size: 0.8rem;
  
  &::after {
    content: '';
    width: 1.5px;
    height: 50px;
    background-color: ${props => props.theme.colors.text.secondary};
    margin-top: 0.5rem;
    animation: scroll 2s ease-in-out infinite;
  }
  
  @keyframes scroll {
    0% {
      height: 0;
      opacity: 0;
    }
    50% {
      height: 50px;
      opacity: 1;
    }
    100% {
      height: 0;
      opacity: 0;
    }
  }
`;

const Hero = () => {
  return (
    <HeroSection id="home">
      <HeroContent>
        <HeroTitle>Nicholas Bentley</HeroTitle>
        <HeroSubtitle>Principal Network Engineer</HeroSubtitle>
        <HeroText>
          Professional, hard-working and detail-oriented network engineer with expertise in setting up new networks and ensuring optimal performance.
        </HeroText>
        <CTAButton href="#contact">Get In Touch</CTAButton>
      </HeroContent>
      <ScrollIndicator>Scroll Down</ScrollIndicator>
    </HeroSection>
  );
};

export default Hero;
